const facebookProfileUrl = 'https://www.facebook.com/profile.php';

export function validateUrl(url, type) {
    const validUrls = {
        2: ['facebook.'],
        1: ['yelp.'],
        8: ['trustpilot'],
        9: ['tripadvisor'],
        12: ['instagram.com/'],
        14: ['thefork'],
        15: ['deliveroo'],
        16: ['booking'],
        24: ['youtube'],
        25: ['x.com', 'twitter'],
        26: ['linkedin'],
        27: ['pinterest'],
        28: ['tiktok'],
        29: ['hotels', 'hoteis'],
        30: ['expedia.com'],
        32: ['healthgrades.com'],
        33: ['zocdoc.com'],
        34: ['ratemds.com'],
    };
    const r = /^(ftp|http|https):\/\/[^ "]+$/;
    const isValidTypeUrl = () => {
        let isValid = false;
        validUrls[type].forEach(subUrl => {
            if (url.includes(subUrl)) {
                isValid = true;
            }
        });

        // INFO: Facebook profile url without id is not valid
        if (type === 2 && url.startsWith(facebookProfileUrl) && !url.includes('id=')) {
            isValid = false;
        }
        return isValid;
    };
    return r.test(url) && isValidTypeUrl();
}
